"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.date = void 0;
var fromRefinement_1 = require("./fromRefinement");
var isDate = function (u) { return u instanceof Date; };
/**
 * @since 0.5.0
 */
exports.date = fromRefinement_1.fromRefinement('Date', isDate);
